<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Sales Invoices" searchable="true"></list-nav-header>


            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items" class="no-icons">
                        <a :href="item._links.frontend.view" class="info">
                            <span>{{ item.client }}</span>
                            <span>{{ item.raised }}</span>
                            <span>{{ item.reference }}</span>
                            <span>£{{ item.costs.gross }}</span>
                        </a>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Sales Invoices
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">Reference</th>
                        <th scope="col">Client</th>
                        <th scope="col">Client Reference</th>
                        <th scope="col">Package</th>
                        <th scope="col">Date</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference">{{ item.reference }}</td>
                        <td data-label="Client">{{ item.client }}&nbsp;</td>
                        <td data-label="Client Reference">{{ item.client_reference }}&nbsp;</td>
                        <td data-label="Package" v-if="item.package">
                            <a v-if="item.package.data.project" :href="item.package.data._links.frontend.view"><strong>{{ item.package.data.project }}:</strong> {{ item.package.data.name }}</a>
                            <a v-else :href="item.package.data._links.frontend.view">{{ item.package.data.name }}</a>
                        </td>
                        <td data-label="Package" v-else>No Package</td>
                        <td data-label="Date">{{ item.raised }}</td>
                        <td data-label="Due Date">{{ item.due_date }}</td>
                        <td data-label="Amount">&pound;{{ item.costs.gross }}</td>
                        <td data-label="Status">{{ item.status }}</td>
                    </tr>
                    <tr>
                        <td colspan="9">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Sales Invoices
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props:['compact','packageId','clientType','clientId'],
        data() {
            return {
                name: 'salesinvoices',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            },
            clientId: function(){
                this.getItems();
            },
            clientType: function(){
                this.getItems();
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            getItems() {
                this.items = [];
                var that = this;
                var url = appUrls.salesinvoices.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                if(this.clientId)
                {
                    params.client_id = this.clientId;
                    params.client_type = this.clientType;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
